<template>
  <div class="navbar">
    <template v-if="$windowWidth < 1225">
      <h2 class="navbar__title">{{ t("global.menu") }}</h2>

      <button
          v-if="$router.currentRoute.value.name"
          class="navbar__drawer-btn"
          @click="toggleExpansion"
      >
        {{ t(`routes.${rootRouteName}.name`) }}
        <IconChevron :class="{'icon--rotate-180' : !isExpanded}" class="icon icon--white"/>
      </button>
    </template>

    <Transition name="expand">
      <div
          v-show="!memberIsLoading && (isExpanded || $windowWidth >= 1225  || !$router.currentRoute.value.name)"
          ref="content"
          class="navbar__content"
      >
        <AdminNavbarItems v-if="memberStore.hasRole(Role.Admin)"/>
        <CorporateMemberNavbarItems v-if="memberStore.hasRole(Role.CorporateAdmin)"/>
        <RealEstateBrokerMemberNavbarItems v-if="memberStore.hasRole(Role.RealEstateBroker)"/>
        <SyndicateAdminMemberNavbarItems
            v-if="memberStore.hasOneOfTheseRoles([Role.RegularSyndicateAdmin, Role.RegularSyndicateManager])"/>
        <IndividualAndSyndicateCoownerMemberNavbarItems v-if="memberStore.hasIndividualAndCoOwnerRoles()"/>
        <SyndicateCoownerMemberNavbarItems
            v-if="memberStore.hasRole(Role.RegularSyndicateCoOwner) && !memberStore.hasRole(Role.RegularIndividual)"/>
        <IndividualMemberNavbarItems
            v-if="memberStore.hasRole(Role.RegularIndividual) && !memberStore.hasRole(Role.RegularSyndicateCoOwner)"/>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import {computed, onMounted, ref} from "vue";
import IconChevron from "@/assets/icons/icon__chevron.svg"
import {useI18n} from "vue3-i18n";
import {useRouter} from "vue-router";
import {useMemberStore} from "@/stores/memberStore";
import {Role} from "@/types";
import AdminNavbarItems from "@/components/navigation/AdminNavbarItems.vue";
import CorporateMemberNavbarItems from "@/components/navigation/CorporateMemberNavbarItems.vue";
import SyndicateAdminMemberNavbarItems from "@/components/navigation/SyndicateAdminMemberNavbarItems.vue";
import SyndicateCoownerMemberNavbarItems from "@/components/navigation/SyndicateCoownerMemberNavbarItems.vue";
import IndividualMemberNavbarItems from "@/components/navigation/IndividualMemberNavbarItems.vue";
import IndividualAndSyndicateCoownerMemberNavbarItems
  from "@/components/navigation/IndividualAndSyndicateCoownerMemberNavbarItems.vue";
import RealEstateBrokerMemberNavbarItems from "@/components/navigation/RealEstateBrokerMemberNavbarItems.vue";

// eslint-disable-next-line
const props = defineProps<{
  memberIsLoading: boolean
}>()

const {t} = useI18n()

const memberStore = useMemberStore()

let isExpanded = ref<boolean>(true);
let content = ref<HTMLElement>();
let height = ref<string>();

const router = useRouter();
const currentRoute = ref(router.currentRoute);
let rootRouteName = computed(() => {
  let name = currentRoute.value.name;

  if (currentRoute.value.matched[0] != null) {
    name = currentRoute.value.matched[0].name
  }

  return name?.toString()
})


onMounted(() => {
  height.value = `${
      content.value != undefined ? content.value.scrollHeight : 0
  }px`;

  //close it once we have the scroll value
  toggleExpansion();
});

function toggleExpansion() {
  isExpanded.value = !isExpanded.value;
}
</script>

<style lang="scss" scoped>
.expand-leave-active,
.expand-enter-active {
  transition: max-height 0.2s cubic-bezier(0.69, 0.33, 0.16, 0.97);
  overflow: hidden;
}

.expand-enter-to,
.expand-leave-from {
  max-height: v-bind(height);
}

.expand-enter-from,
.expand-leave-to {
  max-height: 0;
}
</style>
